import { routes as communityRoutes } from '@communities/routes';

import { extractRedirectFromParams } from './extractRedirectFromParams';

const DEFAULT_REDIRECT_PATH = communityRoutes.communityGroups.root;

/**
 * Constructs post auth redirect URL with version path awareness
 * Automatically includes version prefix if current deployment is versioned
 * @param searchParams URLSearchParams object to check for redirect parameter
 * @returns Redirect URL with version prefix if applicable, or undefined if no redirect needed
 */
export function constructPostAuthRedirect(searchParams: URLSearchParams): string | undefined {
  // Extract the base redirect URL from parameters
  const baseRedirectUrl = extractRedirectFromParams(searchParams);

  // Check if current deployment is versioned
  const pathSegments = window.location.pathname.split('/');
  const versionPrefix = pathSegments[1]?.match(/^v\d+\.\d+\.\d+$/) ? `/${pathSegments[1]}` : '';

  // If we have a base redirect URL
  if (baseRedirectUrl) {
    // If we have a version prefix and the redirect URL doesn't already include it
    if (versionPrefix && !baseRedirectUrl.startsWith(versionPrefix)) {
      return `${versionPrefix}${baseRedirectUrl}`;
    }

    return baseRedirectUrl;
  }

  // If no redirect URL but we're in a versioned deployment, redirect to versioned default
  if (versionPrefix) {
    return `${versionPrefix}${DEFAULT_REDIRECT_PATH}`;
  }

  // No redirect needed
  return undefined;
}
